import React, { useContext, ReactElement } from 'react'
import { PrimaryAction } from '../helpers/action/Action.d'
import { BasicContextProvided, BasicContextState } from '../helpers/context.d'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faRotateRight } from '@fortawesome/free-solid-svg-icons'
library.add(faRotateRight)

export const ReloadButton = <S extends BasicContextState>(props: {
    context: React.Context<BasicContextProvided<S>>
    action: PrimaryAction
}): ReactElement => {
    const context = useContext(props.context)
    const isLoading = context.state.inProgress && JSON.stringify(props.action) in context.state.inProgress
    return <FontAwesomeIcon
        className="reload-button clickable"
        onClick={ () => context.dispatch({ type: 'CLEAR_ACTION_STATUS', actionToClear: props.action }) }
        icon="rotate-right"
        spin={ isLoading }
    />
}
